import styled from 'styled-components'

const CypressContainer = styled.div`
  display: contents;
`

export { CypressContainer }
